import {forwardRef} from 'react';

import {SizeTokenValue} from 'common';

import {SVG} from './SVG';

import type {IconComponent} from 'icons/types';

const largeIcon = (
  <path
    fillRule="evenodd"
    clipRule="evenodd"
    d="M19 3C19 2.44772 18.5523 2 18 2C17.4477 2 17 2.44772 17 3V9.58579L15.7071 8.29289C15.3166 7.90237 14.6834 7.90237 14.2929 8.29289C13.9024 8.68342 13.9024 9.31658 14.2929 9.70711L17.2929 12.7071C17.6834 13.0976 18.3166 13.0976 18.7071 12.7071L21.7071 9.70711C22.0976 9.31658 22.0976 8.68342 21.7071 8.29289C21.3166 7.90237 20.6834 7.90237 20.2929 8.29289L19 9.58579V3ZM8 8H4C3.45 8 3 8.45 3 9C3 9.55 3.45 10 4 10H8C8.55 10 9 9.55 9 9C9 8.45 8.55 8 8 8ZM4 18C3.45 18 3 18.45 3 19C3 19.55 3.45 20 4 20H20C20.55 20 21 19.55 21 19C21 18.45 20.55 18 20 18H4ZM15 14C15 13.45 14.55 13 14 13H4C3.45 13 3 13.45 3 14C3 14.55 3.45 15 4 15H14C14.55 15 15 14.55 15 14Z"
  />
);

const smallIcon = (
  <path
    fillRule="evenodd"
    clipRule="evenodd"
    d="M13.0651 3.00006C13.0651 2.68802 12.8121 2.43506 12.5001 2.43506C12.188 2.43506 11.9351 2.68802 11.9351 3.00006V7.63603L10.8996 6.60054C10.6789 6.3799 10.3212 6.3799 10.1005 6.60054C9.8799 6.82119 9.8799 7.17893 10.1005 7.39957L12.1005 9.39957C12.3212 9.62022 12.6789 9.62022 12.8996 9.39957L14.8996 7.39957C15.1202 7.17893 15.1202 6.82119 14.8996 6.60054C14.6789 6.3799 14.3212 6.3799 14.1005 6.60054L13.0651 7.63603V3.00006ZM2.565 13C2.25296 13 2 13.253 2 13.565C2 13.877 2.25296 14.13 2.565 14.13H13.435C13.747 14.13 14 13.877 14 13.565C14 13.253 13.747 13 13.435 13H2.565ZM2 10.565C2 10.253 2.25296 10 2.565 10H9.435C9.74704 10 10 10.253 10 10.565C10 10.877 9.74704 11.13 9.435 11.13H2.565C2.25296 11.13 2 10.877 2 10.565ZM2.565 7C2.25296 7 2 7.25296 2 7.565C2 7.87704 2.25296 8.13 2.565 8.13H5.435C5.74704 8.13 6 7.87704 6 7.565C6 7.25296 5.74704 7 5.435 7H2.565Z"
  />
);

export const SortAZIcon: IconComponent = forwardRef((props, ref) => {
  const {size} = props;

  return (
    <SVG ref={ref} name="SortAZ" {...props}>
      {!size || size === SizeTokenValue.Large || size === SizeTokenValue.Medium ? largeIcon : smallIcon}
    </SVG>
  );
});
